// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CachedEntityDeltaList } from '@/audit/api/types';
import { Stack, Typography } from '@mui/material';

type LabelOverride = Record<string, string>;

const LABEL_OVERRIDE: LabelOverride = {
  // Asset update audit
  '23f23cc0-70c0-4973-8704-30040103a756': 'Attached assets',
  // Project update audit
  '798b764f-3caa-41d2-a00b-d4324161b327': 'Attached projects',
};

interface Props {
  property: CachedEntityDeltaList;
}

export function AuditCachedEntityDeltaListLabel(props: Props) {
  const entities = [
    ...(props.property.newValue?.added
      ?.sort((a, b) => a.name.localeCompare(b.name))
      .map((value) => ({
        ...value,
        isNew: true,
      })) || []),
    ...(props.property.newValue?.removed
      ?.sort((a, b) => a.name.localeCompare(b.name))
      .map((value) => ({
        ...value,
        isNew: false,
      })) || []),
  ];
  return (
    <Stack>
      <Typography component="span" variant="caption" fontWeight="bold">
        {LABEL_OVERRIDE[props.property.id] || props.property.name}:
      </Typography>
      {entities.map(({ id, name, isNew }) => {
        return (
          <Typography key={id} variant="caption" marginLeft={2}>
            <Typography component="span" variant="inherit">
              {name}
            </Typography>{' '}
            <Typography
              component="span"
              variant="inherit"
              sx={{ textDecoration: 'underline' }}
            >
              {isNew ? 'added' : 'removed'}
            </Typography>
          </Typography>
        );
      })}
    </Stack>
  );
}
